import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Comment, CommentId, CommentSubject } from 'models/Comment';
import {
  commentQuery,
  commentsQuery,
} from 'networking/mindfeed/queries/comments';
import { createComment } from 'networking/mindfeed/services/comment.service';

type Variables = {
  content: string;
  subject: CommentSubject;
  parentId?: CommentId;
};

export const useCreateComment = ({
  onSuccess,
}: {
  onSuccess?: (comment: Comment) => void;
} = {}) => {
  const queryClient = useQueryClient();

  return useMutation<Comment, unknown, Variables>({
    mutationFn: ({ subject, content, parentId }) =>
      createComment(subject, { content, parentId }),
    onSuccess: (comment, { subject, parentId }) => {
      queryClient.invalidateQueries({
        queryKey: commentsQuery(subject).queryKey,
      });
      if (parentId) {
        queryClient.invalidateQueries({
          queryKey: commentQuery(parentId).queryKey,
        });
      }
      onSuccess?.(comment);
    },
  });
};
